export class ExceptionZonesEntityModel {
  Id: string;
  ExceptionAreaOrNeighbourhood: string;
  ItemNumber: number;
}
